import { render, staticRenderFns } from "./InformePlazosTab.vue?vue&type=template&id=39d497ed"
import script from "./InformePlazosTab.vue?vue&type=script&setup=true&lang=js"
export * from "./InformePlazosTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports